const cloneObject = (obj) => {
    try {
        return JSON.parse(JSON.stringify(obj));
    } catch (e) {
        console.error(e);
    }

    return null;
}
export default cloneObject;